import { Injectable } from '@angular/core';
import { FspDocumentsRequestGridDto } from '../../../free-services-documents-grid/fsp-documents-grid-data-model';
import { GridDataService } from '../../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspBuildingsDocsGridDataService extends GridDataService<FspDocumentsRequestGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
